// Matrice par défaut pour le coloriage des caractères
// Utilisée sur la page StoryPage pour les sections 13 et 14

const defaultMatrice = {
  lettres_couleurs: {
    "A": "#d51c15",
    "B": "#2d4ee1",
    "C": "#4cca16",
    "D": "#e29312",
    "E": "#2a72cf",
    "F": "#17a9e8",
    "G": "#31be2d",
    "H": "#3e4ec1",
    "I": "#cedb1f",
    "J": "#3ce01f",
    "K": "#e7820d",
    "L": "#cee21a",
    "M": "#5271c7",
    "N": "#d88922",
    "O": "#cfc426",
    "P": "#21d62a",
    "Q": "#fe62c5",
    "R": "#348adf",
    "S": "#cc2d21",
    "T": "#20e4ee",
    "U": "#229fdd",
    "V": "#21b644",
    "W": "#c2d62f",
    "X": "#e73323",
    "Y": "#e78d18",
    "Z": "#187adc"
  },
  chiffres_couleurs: {
    "0": "#2366e1",
    "1": "#147ae1",
    "2": "#d63324",
    "3": "#e8eb19",
    "4": "#3e72cc",
    "5": "#c53734",
    "6": "#be3737",
    "7": "#2cce2c",
    "8": "#365ece",
    "9": "#247bc2"
  }
};

export default defaultMatrice;
